import * as Sentry from '@sentry/browser';
import { useTranslation as i18nextUseTranslation } from 'react-i18next';

// @ts-ignore: paraglide is vanilla JS
import * as m from '@klaviyo-mkt/i18n/paraglide/messages';
// @ts-ignore: paraglide is vanilla JS
import { languageTag } from '@klaviyo-mkt/i18n/paraglide/runtime';

const useLegacyTranslation = () => {
  const { t, i18n } = i18nextUseTranslation();

  return ({
    t,
    i18n: {
      language: i18n.language,
    },
  });
};

const useParaglideTranslation = () => ({
  t: (key: string, options?: object) => {
    // eslint-disable-next-line import/namespace
    if (m[key]) {
      // eslint-disable-next-line import/namespace
      return m[key](options);
    }
    Sentry.captureException(
      `Translation key "${key}" not found`,
      {
        level: 'warning',
        extra: {
          key,
          options,
        },
      },
    );
    console.warn(`Translation key "${key}" not found`);
    return '';
  },
  i18n: {
    language: languageTag(),
  },
});

/**
 * Used for backwards-compatibility with i18next.
 * If your component will be used with Astro and Gatsby, use this hook.
 * If your component will only be used with Astro, use import * as m from '../paraglide/messages';.
 */
export const useTranslation = process.env.GENERATOR === 'gatsby' ? useLegacyTranslation : useParaglideTranslation;
